import React from "react";
import styles from "./coming-soon-chip.module.scss";

const ComingSoonChip = () => {
  return (
    <span className={styles.chip}>
      coming soon
    </span>
  );
};

export default ComingSoonChip;

